import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CreateEvent, initialState } from "./types";

export const createEventSlice = createSlice({
  name: 'createEvent',
  initialState,
  reducers:{
    reset: () => initialState,
    apply: (state, action: PayloadAction<Partial<CreateEvent>>) => {
      return { ...state, ...action.payload };
    },
  }
})
export const {reset, apply} = createEventSlice.actions
export default createEventSlice.reducer